import React from 'react'
import { Navbar } from '../../components/navbar'

const Contact = () => {
  return (
    <>
        <Navbar/>
    <div>Contact</div>

    </>
  )
}

export default Contact